import { subscribeList, deleteSubscribe, addSubscribe, editsubGroup } from '../../service'
import store from '../../store'
const attention_entity_mixins = {
  inject: ['haddleApplyTry'],
  data() {
    return {
      show_input: false,
      input_value: '',
      change_drop: 'cancel'
      // subscribe_grouped: []
    }
  },

  computed: {
    length_of_subscribe() {
      if (this.$store.state.attention.group) {
        return this.$store.state.attention.group.length
      } else {
        return 0
      }
    },
    subscribe_group() {
      return this.$store.state.attention.group
    },
    subscribe() {
      return this.$store.state.attention.subscribe
    },
    grouped() { // 已关注
      if (!this.$store.state.attention) {
        return []
      }
      let e = this.$store.state.attention.subscribe.find(item => item.sub_type_id == this.detail.id)
      if (e) {
        return this.$store.state.attention.g_relation.filter(item => item.subscribe_id == e.id).map(item => item.group_id)
      } else {
        return []
      }
    },
    _ids_comp() { // 已关联公司
      if (this.$store.state.attention.subscribe) {
        return this.$store.state.attention.subscribe.filter((item) => {return item.sub_type == '0'}).map((item) => {return item.sub_type_id})
      } else {
        return []
      }
    },
    _ids_org() { // 已关联公司
      if (this.$store.state.attention.subscribe) {
        return this.$store.state.attention.subscribe.filter((item) => {return item.sub_type == '1'}).map((item) => {return item.sub_type_id})
      } else {
        return []
      }
    }
  },
  methods: {
    add(id, type) {
      this.button_loading = true
      this.attentionAdd(id, type, this.params.group_id, () => {
        this.attention_visible = false
        this.show_input = false
        this.$refs['attention_g_form'].resetFields()
        this.button_loading = false
      })
    },
    cancelAttention(at) {
      this.attention_visible = false
      this.show_input = false
      this.$refs[at].resetFields()
    },
    async createGroup() { // 新建分组
      if(this.subscribe_group.findIndex(item => item.name == this.input_value) != -1) {
        this.$Message.warning('该分组已存在！')
        return
      }
      if (this.input_value == '') {
        this.$Message.warning('分组名不能为空！')
        return
      }
      if (this.input_value.length > 9) {
        this.$Message.warning('分组名长度不能超过10个字！')
        return
      }
      this.createGroupLimt(async () => {
        let res = await editsubGroup({
          user_key: store.state.user_key,
          name: this.input_value
        }, (error) => {  this.$Message.error('请求错误！') })
        if(res.status == 'success') {
          this.inputBlur()
          this.refresh()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    cancelEntity(e, sid) {
      let id = this.$store.state.attention.subscribe.find((item) => {return item.sub_type_id == sid}).id
      let temp = {
        user_key: this.$store.state.user_key,
        op_type: 'cancel',
        subscribe_id: id
      }
      this.delsubscribe(temp)
    },
    async attentionAdd(id, sub_type, group_id, cb) { // 添加关注
      this.addAttentionLimt(sub_type, async () => {
        let res = await addSubscribe({
          "user_key": store.state.user_key,
          "sub_type": sub_type,
          "sub_type_id": id,
          "group_id": group_id,
        }, (error) => {this.$Message.error('请求失败！')})
        if(res.status == 'success'){
          this.$Message.success('关注成功！')
          if(sub_type == 0){
            _czc.push(['_trackEvent', '公司详情', '关注成功点击'])
          }else if(sub_type == 1){
            _czc.push(['_trackEvent', '机构详情', '关注成功点击'])
          }
          this.refresh(cb)
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    async delsubscribe(obj, cb) { // 取消关注
      let res = await deleteSubscribe(obj, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {

        let m_obj = this.subscribe.find((a) => {
          return a.id == obj.subscribe_id
        })
        if(m_obj.sub_type == 0){
          _czc.push(['_trackEvent', '公司详情', '取消关注点击'])
        }else if(m_obj.sub_type == 1){
          _czc.push(['_trackEvent', '机构详情', '取消关注点击'])
        }
        this.refresh(cb)
        this.$Message.success('取消成功！')
      } else {
        this.$Message.error(res.message)
      }
    },
    async refresh(cb, type) { // 刷新状态
      let res = await subscribeList({
        user_key: store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation:res.g_relation,
          group:res.group,
          subscribe:res.subscribe
        })
        if (cb) {
          if (type) {
            cb
          } else {
            cb()
          }
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    inputBlur() { // 失去焦点
      setTimeout(() => {
        this.show_input = false
        this.input_value = ''
      }, 500)
    },
    async zanbu(id, type) {
      let index = this.subscribe_group.findIndex(item => item.name == '暂不分组')
      // if(index != -1) { // 有暂不分组的情况
        this.attentionAdd(id, type, '', () => {
          this.attention_visible = false
          this.show_input = false
          this.$refs['attention_g_form'].resetFields()
          this.button_loading = false
        })
      // } else {
      //   let res = await editsubGroup({
      //     user_key: store.state.user_key,
      //     name: '暂不分组'
      //   }, (error) => {  this.$Message.error('请求错误！') })
      //   if(res.status == 'success') {
      //     this.refresh(this.attentionAdd(id, type, [res.res], () => {
      //       this.attention_visible = false
      //       this.show_input = false
      //       this.$refs['attention_g_form'].resetFields()
      //       this.button_loading = false
      //     }), 1)
      //     // this.cancelAttention()
      //   } else {
      //     this.$Message.error(res.message)
      //   }
      // }
    },
    move(e, sid) {
      // if (this.params.group_id.length == this.grouped.length) { // 如果全部移除为取消
      //   this.cancelEntity(e, sid)
      // } else {
        // let dfrcset = [...new Set([...this.grouped].filter(x => this.params.group_id.indexOf(x) == -1))]
        let id = this.$store.state.attention.subscribe.find((item) => {return item.sub_type_id == sid}).id
        for(let i of this.params.group_id) {
          this.delsubscribe({
            "user_key": store.state.user_key,
          	"subscribe_id": id,
          	"group_id": i,
          	"op_type": "move",
          })
        }
      // }
      this.cancelAttention('attention_g_c_form')
    },
    subscribe_grouped(s){
      if (this.grouped.indexOf(s.id) != -1) {
        return true
      } else {
        return false
      }
    },
    changeDrop(name) {
      this.change_drop = name
      if (name == 'cancel') {
        layer.confirm('确定不再关注？<br />取消关注，其他分组同步取消哦~', {
          title: false,
          offset: '100px',
          skin: 'layer-custom',
          btn: ['确定','取消'] //按钮
        }, () => {
          this.cancelEntity('cancel', this.detail.id)
          layer.closeAll()
        }, () => {
          layer.closeAll()
        })
      }
    },
    clickoutside(e) {
      if (this.change_drop != 'move') {
        this.attention_visible = false
      }
    },
    addAttentionLimt(type,cb) { // 添加关注限制
      if(this.$store.state.user_key) {
        let k_v = {
          '0': '公司',
          '1': '机构'
        }
        let arr = this.$store.state.attention.subscribe.filter(item => item.sub_type == type)
        if(arr.length>=30) {
          this.haddleApplyTry('温馨提示', '最多关注30家'+k_v[type]+'，动脉橙机构版无限制，欢迎试用动脉橙机构版。', 25)
        } else {
          cb()
        }
        // if(this.isVIP) {
        //   if(arr.length>=30) {
        //     if('org_modal' in this.$refs) {
        //       this.$refs['org_modal'].goShow()
        //       this.org_modal_img = 'szgz'
        //       this.org_modal_p = `VIP用户支持20个${k_v[type]}关注。如果您有需求，可联系我们工作人员`
        //     } else {
        //       this.$Message.info(`VIP用户支持20个${k_v[type]}关注。如果您有需求，可联系我们工作人员`)
        //     }
        //     if(this.$route.name == 'CompanyDetail' || this.$route.name == 'OrgDetail') {
        //       this.button_loading = false
        //       this.attention_visible = false
        //       this.show_input = false
        //       this.$refs['attention_g_form'].resetFields()
        //     }
        //     return
        //   } else {
        //     cb()
        //   }
        // } else {
        //   if(arr.length>=10) {
        //     if('org_modal' in this.$refs) {
        //       this.$refs['org_modal'].goShow()
        //       this.org_modal_img = 'szgz'
        //       this.org_modal_p = `普通用户支持10个${k_v[type]}关注。如果您有需求，可联系我们工作人员`
        //     } else {
        //       this.$Message.info(`普通用户支持10个${k_v[type]}关注。如果您有需求，可联系我们工作人员`)
        //     }
        //     if(this.$route.name == 'CompanyDetail' || this.$route.name == 'OrgDetail') {
        //       this.button_loading = false
        //       this.attention_visible = false
        //       this.show_input = false
        //       this.$refs['attention_g_form'].resetFields()
        //     }
        //     return
        //   } else {
        //     cb()
        //   }
        // }
      } else {
        this.login()
      }
    }
  },
  // watch: {
  //   grouped(val) {
  //     this.params.group_id = [...val]
  //   }
  // }
}

export { attention_entity_mixins }
